module.exports = __webpack_public_path__ + "img/hero-tape-measure.3f751bc7.png";